import React, { useState, useEffect } from "react";
import "../../Styles/Enquery.css";
import { Header } from "../Core/Header";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { getreviewQuestionApi, submitReview } from "../Services/Operations/ProductAPI";

const Review = () => {
  const [reviewQuestions, setReviewQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const response = await getreviewQuestionApi();
        console.log("response : ",response)
        const questions = response || [];
        setReviewQuestions(questions);
        setAnswers(Array(questions.length).fill("")); 
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchReview();
  }, []);

  const handleAnswerChange = (index, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index] = value;
    setAnswers(updatedAnswers);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (answers.some((a) => !a.trim())) {
    toast.error("Please answer all questions before submitting.");
    return;
  }

  const userId = 123;

  const formattedAnswers = reviewQuestions.map((question, index) => ({
    questionId: question._id || question.id,
    answer: answers[index],
  }));

  const submittedData = {
    userId,
    answers: formattedAnswers,
  };

  try {
    const response = await submitReview(submittedData);
    console.log("response : ",response);
    if (response?.status === true) {
      toast.success(response.message);
      setAnswers(Array(reviewQuestions.length).fill("")); 
    } else {
      toast.error("Failed to submit answers.");
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("An error occurred while submitting.");
  }
};


  return (
    <div className="review-container" style={{marginTop:"150px"}}>
      <Header />
      <div className="review-content container mt-5 p-4 rounded bg-white">
        <h3 className="text-center mb-4">Review Questions</h3>
        <form onSubmit={handleSubmit}>
          {reviewQuestions.map((question, index) => (
            <div key={index} className="mb-4">
              <label className="form-label fw-bold">
                {index + 1}. {question.questionText}
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Type your answer here..."
                value={answers[index]}
                onChange={(e) => handleAnswerChange(index, e.target.value)}
                required
              />
            </div>
          ))}
          <div className="text-center mt-4">
            <button type="submit" className="btn btn-primary px-4">
              Submit Answers
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Review;
